<template>
  <span>
    <filter-value-suggester :value="value" @input="newValue" v-if="fieldFormat === 'string'" :field="field" :filters="filters" :start-time="startTime" :end-time="endTime"></filter-value-suggester>
    <b-select v-else-if="fieldFormat === 'boolean'" :value="value" @input="newValue" :options="{ true: 'True', false: 'False'}">
      <template slot="first">
        <option :value="''" disabled>Select value</option>
      </template>
    </b-select>
    <b-input v-else-if="fieldFormat === 'number' || fieldFormat === 'timestamp'" type="number" :value="value" @input="newValue" @keyup.enter.native="addFilter" placeholder="select value">
    </b-input>
    <b-form-input v-else :value="value" @input="newValue" @keyup.enter.native="addFilter" placeholder="select value"></b-form-input>
  </span>
</template>

<script>
import FilterValueSuggester from '@/reports/components/FilterValueSuggester'
import { getFieldFormat } from '@/reports/components/ReportUtils'

export default {
  props: {
    field: { required: true, type: String },
    value: { required: true, type: String },
    filters: { required: false, type: Array }, //these are filters for filtering filterValueSuggester suggested values
    startTime: { required: false, type: Number },
    endTime: { required: false, type: Number }
  },
  data () {
    return {

    }
  },
  methods: {
    getFieldFormat,
    addFilter() {
      this.$emit('addFilter')
    },
    newValue(newValue) {
      this.$emit('input', newValue)
    }
  },
  computed: {
    fieldFormat() {
      return this.getFieldFormat(this.field)
    }
  },
  components: {
    FilterValueSuggester
  }
}
</script>



// WEBPACK FOOTER //
// src/reports/components/FilterValueSelector.vue